let baseurl = "/api/batteryplant";
// let baseurl = "/api";
//登录
let UserLogin = baseurl + "/api/Login/UserLogin";
//账户管理列表
let LoginUserList = baseurl + "/api/UserAdmin/LoginUserList";
//启用禁用用户
let EnableUnableUser = baseurl + "/api/UserAdmin/EnableUnableUser";
//账户注册或修改
let UserRegister = baseurl + "/api/UserAdmin/UserRegister";

// 产品类型新增或修改
let ProductTypeRegister = baseurl + "/api/ProductAdmin/ProductTypeRegister";
// 产品类型管理列表
let ProductTypeList = baseurl + "/api/ProductAdmin/ProductTypeList";
// 删除恢复产品类型
let VoidRecoverProductType =
  baseurl + "/api/ProductAdmin/VoidRecoverProductType";
// 产品新增或修改
let ProductRegister = baseurl + "/api/ProductAdmin/ProductRegister";
// 产品管理列表
let ProductList = baseurl + "/api/ProductAdmin/ProductList";
// 删除恢复产品
let VoidRecoverProduct = baseurl + "/api/ProductAdmin/VoidRecoverProduct";

// 产品详细信息编辑
let ProductDetailsEdit = baseurl + "/api/ProductAdmin/ProductDetailsEdit";
// 文件管理列表
let ProductAdminList = baseurl + "/api/ProductAdmin/ProductAdminList";
// 勾选与取消勾选
let UpdateIsShow = baseurl + "/api/ProductAdmin/UpdateIsShow";
// 删除文件
let DeleteFile = baseurl + "/api/ProductAdmin/DeleteFile";
// 上传文件
let ProductAdminUploadFile =
  baseurl + "/api/ProductAdmin/ProductAdminUploadFile";
// 分类新增或修改
let CaseRegister = baseurl + "/api/CaseAdmin/CaseRegister";
// 分类管理列表
let CaseList = baseurl + "/api/CaseAdmin/CaseList";
// 删除恢复分类
let VoidRecoverCase = baseurl + "/api/CaseAdmin/VoidRecoverCase";
// 分类文件管理列表
let CaseAdminList = baseurl + "/api/CaseAdmin/CaseAdminList";
//目的属性下拉框
let OrdersIntentionDown = baseurl + "/api/Website/OrdersIntentionDown";
//网站联系我们客户提交
let ContactUsSubmit = baseurl + "/api/Website/ContactUsSubmit";
// 订单管理列表
let OrderAdminList = baseurl + "/api/OrderAdmin/OrderAdminList";
// 删除恢复订单
let VoidRecoverOrder = baseurl + "/api/OrderAdmin/VoidRecoverOrder";
// 订单目的属性新增或修改
let OrdersIntentionRegister =
  baseurl + "/api/OrderAdmin/OrdersIntentionRegister";
// 订单目的属性管理列表
let OrdersIntentionList = baseurl + "/api/OrderAdmin/OrdersIntentionList";
// 删除订单目的属性
let VoidOrdersIntention = baseurl + "/api/OrderAdmin/VoidOrdersIntention";
// case页面图片列表
let CasePageList = baseurl + "/api/Website/CasePageList";
// 首页轮播图
let HomePageProductCarouselDisplay = baseurl + "/api/Website/HomePageProductCarouselDisplay";
//===========================qiantai============================
// 产品类别
let WebsiteProductType = baseurl + "/api/Website/WebsiteProductType";
// 该产品类型下各产品概括列表
let ProductSummarizeList = baseurl + "/api/Website/ProductSummarizeList";
// 点击产品进入产品详页
let ProductInformation = baseurl + "/api/Website/ProductInformation";
export {WebsiteProductType,ProductSummarizeList,ProductInformation,
  CasePageList, HomePageProductCarouselDisplay, OrdersIntentionDown, ContactUsSubmit,
  OrdersIntentionRegister,
  OrdersIntentionList,
  VoidOrdersIntention,
  OrderAdminList,
  VoidRecoverOrder,
  CaseRegister,
  CaseList,
  VoidRecoverCase,
  CaseAdminList,
  UserLogin,
  LoginUserList,
  EnableUnableUser,
  UserRegister,
  ProductTypeRegister,
  ProductTypeList,
  VoidRecoverProductType,
  ProductRegister,
  ProductList,
  VoidRecoverProduct,
  ProductDetailsEdit,
  ProductAdminList,
  UpdateIsShow,
  DeleteFile,
  ProductAdminUploadFile,
};
